module.exports = __webpack_public_path__ + "img/badge_color_fia-scholarship.0d4da11b.svg";